/* eslint-disable react/prop-types */
import ReactDOM from 'react-dom';
import { AiOutlineLeft, AiOutlineRight } from 'react-icons/ai';

function ChangeMonthButton({ ariaLabel, icon, onClick }) {
  return (
    <button
      aria-label={ariaLabel}
      className="flex items-center h-full text-base"
      onClick={onClick}
      type="button"
    >
      {icon}
    </button>
  );
}

/**
 * Displays left, right control buttons for DetailsCalendar through portals
 *
 * @param {*} props.controlsHtmlContainers html container for buttons where buttons should be
 *   portaled in
 * @param {func} leftOnClick callback for when left button is clicked
 * @param {func} rightOnClick callback for when right button is clicked
 * @param {boolean} showLeftButton determines visibility of left button
 * @param {boolean} showRightButton determines visibility of right button
 */
export function CalendarControls(props) {
  return (
    <>
      {props.showLeftButton &&
        ReactDOM.createPortal(
          <ChangeMonthButton
            ariaLabel="Scroll to prior month"
            onClick={props.leftOnClick}
            icon={<AiOutlineLeft />}
          />,
          props.controlsHtmlContainers.left
        )}

      {props.showRightButton &&
        ReactDOM.createPortal(
          <ChangeMonthButton
            ariaLabel="Scroll to next month"
            onClick={props.rightOnClick}
            icon={<AiOutlineRight />}
          />,
          props.controlsHtmlContainers.right
        )}
    </>
  );
}
